"use strict";

// 入力フォームのご注意（template-parts/caution.php）
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
});

const setUpAccordion = () => {
  const details = document.querySelectorAll(".p-caution__content");
  const IS_OPENED_CLASS = "is-opened";

  details.forEach((element) => {
    const summary = element.querySelector(".p-caution__contentHead");
    const content = element.querySelector(".p-caution__contentBody");

    if (!summary || !content) return;

    if (!element.hasAttribute("open")) {
      content.style.height = "0";
      content.style.opacity = "0";
    }

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        element.classList.remove(IS_OPENED_CLASS);
        const contentHeight = content.scrollHeight;
        content.style.height = `${contentHeight}px`;
        requestAnimationFrame(() => {
          content.style.height = "0";
          content.style.opacity = "0";
        });
        content.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
            element.removeAttribute("open");
            content.removeEventListener("transitionend", handler);
          }
        });
      } else {
        element.classList.add(IS_OPENED_CLASS);
        element.setAttribute("open", "true");

        content.style.height = "0";
        content.style.opacity = "0";

        const contentHeight = content.scrollHeight;

        requestAnimationFrame(() => {
          content.style.height = `${contentHeight}px`;
          content.style.opacity = "1";
        });

        content.addEventListener("transitionend", function handler(e) {
          if (e.propertyName === "height") {
            content.style.height = "auto";
            content.removeEventListener("transitionend", handler);
          }
        });
      }
    });
  });
};
